import { Injectable } from '@angular/core';
import { ToastrService, ActiveToast } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { MessageDialogComponent } from '@cpd-app/shared-module/components/message-dialog/message-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  constructor(
    private toastr: ToastrService,
    private dialog: MatDialog
  ) {}

  public createWarningMessage(
    title: string,
    message: string
  ): ActiveToast<any> {
    return this.toastr.warning(message, title, {
      disableTimeOut: true,
      enableHtml: true
    });
  }

  public createMessageDialog(title: string, message: string): void {
    this.dialog.open(MessageDialogComponent, {
      ariaLabel: 'Message',
      data: {
        title: title,
        content: message
      }
    });
  }
}
